var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center mt-2 mb-3 flex-wrap" },
        _vm._l(_vm.colorPresets, function (preset, key) {
          return _c(
            "b-button",
            {
              key: key,
              staticClass: "text-capitalize color-preset mb-2",
              class: [`preset-${key}`],
              attrs: {
                variant: `${key === _vm.activePreset ? "" : "outline-"}primary`,
                size: "sm",
              },
              on: {
                click: function ($event) {
                  return _vm.useColorPreset(key)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(key) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Text Color Type", "label-cols": "4" } },
        [
          _c("b-form-radio-group", {
            attrs: {
              options: _vm.colorTypeOptions,
              buttons: "",
              "button-variant": "outline-primary",
              size: "sm",
            },
            on: { change: _vm.onColorTypeChange },
            model: {
              value: _vm.colorType,
              callback: function ($$v) {
                _vm.colorType = $$v
              },
              expression: "colorType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.editor.type === "linear" || _vm.editor.type === "radial",
              expression:
                "editor.type === 'linear' || editor.type === 'radial'",
            },
          ],
          attrs: { label: "Gradient Angle", "label-cols": "4" },
        },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: {
                          max: "360",
                          min: "0",
                          number: "",
                          type: "number",
                        },
                        on: { input: _vm.redraw },
                        model: {
                          value: _vm.editor.angle,
                          callback: function ($$v) {
                            _vm.$set(_vm.editor, "angle", $$v)
                          },
                          expression: "editor.angle",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-input-group-text", [_vm._v("°")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: "360", min: "0", number: "", type: "range" },
                on: { input: _vm.redraw },
                model: {
                  value: _vm.editor.angle,
                  callback: function ($$v) {
                    _vm.$set(_vm.editor, "angle", $$v)
                  },
                  expression: "editor.angle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "angle-indicator mt-2" }, [
            _c(
              "div",
              {
                staticClass: "angle-arrow",
                style: { transform: `rotate(${_vm.editor.angle}deg)` },
              },
              [_vm._v("\n        →\n      ")]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Text Opacity", "label-cols": "4" } },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: {
                          max: "100",
                          min: "0",
                          number: "",
                          type: "number",
                        },
                        on: { input: _vm.redraw },
                        model: {
                          value: _vm.editor.transparency,
                          callback: function ($$v) {
                            _vm.$set(_vm.editor, "transparency", $$v)
                          },
                          expression: "editor.transparency",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-input-group-text", [_vm._v("%")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: "100", min: "0", number: "", type: "range" },
                on: { input: _vm.redraw },
                model: {
                  value: _vm.editor.transparency,
                  callback: function ($$v) {
                    _vm.$set(_vm.editor, "transparency", $$v)
                  },
                  expression: "editor.transparency",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.editor.type === "linear" || _vm.editor.type === "radial",
              expression:
                "editor.type === 'linear' || editor.type === 'radial'",
            },
          ],
          attrs: { label: "Color Stops", "label-cols": "4" },
        },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: {
                          max: "5",
                          min: "2",
                          number: "",
                          type: "number",
                        },
                        on: { input: _vm.colorsNumChange },
                        model: {
                          value: _vm.colorsNum,
                          callback: function ($$v) {
                            _vm.colorsNum = $$v
                          },
                          expression: "colorsNum",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-input-group-text", [_vm._v("stops")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: "5", min: "2", type: "range" },
                on: { input: _vm.colorsNumChange },
                model: {
                  value: _vm.colorsNum,
                  callback: function ($$v) {
                    _vm.colorsNum = $$v
                  },
                  expression: "colorsNum",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Colors", "label-cols": "4" } },
        [
          _vm.colorType === "solid"
            ? [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mb-2" },
                  [
                    _c("b-input", {
                      staticClass: "color-fill-item mr-2",
                      attrs: { debounce: "50", type: "color" },
                      on: { input: _vm.redraw },
                      model: {
                        value: _vm.editor.colors[0],
                        callback: function ($$v) {
                          _vm.$set(_vm.editor.colors, 0, $$v)
                        },
                        expression: "editor.colors[0]",
                      },
                    }),
                    _vm._v(" "),
                    _c("b-input", {
                      staticClass: "flex-grow-1",
                      attrs: {
                        type: "text",
                        placeholder: "Enter hex color (e.g., #FF5733)",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onInputColor($event, 0)
                        },
                      },
                      model: {
                        value: _vm.editor.colors[0],
                        callback: function ($$v) {
                          _vm.$set(_vm.editor.colors, 0, $$v)
                        },
                        expression: "editor.colors[0]",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.editor.type === "linear" || _vm.editor.type === "radial"
            ? _c("ColorStop", {
                attrs: {
                  "active-color": _vm.activeColor,
                  editor: _vm.editor,
                  "show-color-picker": _vm.showColorPicker,
                  tabindex: "0",
                },
                on: {
                  colorStepsInput: _vm.updateStepOfColor,
                  colorStopClicked: _vm.setActiveColor,
                  colorUpdated: _vm.updateColor,
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Live Preview", "label-cols": "4" } },
        [
          _c(
            "div",
            { staticClass: "text-preview", style: _vm.getPreviewStyle() },
            [_vm._v("\n      Sample Gradient Text\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "CSS Output", "label-cols": "4" } },
        [
          _c(
            "div",
            { staticClass: "css-output-container" },
            [
              _c("b-textarea", {
                ref: "cssOutput",
                staticClass: "css-output",
                attrs: { value: _vm.getCSSOutput(), readonly: "", rows: "4" },
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "copy-btn",
                  attrs: { size: "sm", variant: "outline-secondary" },
                  on: { click: _vm.copyCSSToClipboard },
                },
                [_c("b-icon", { attrs: { icon: "clipboard" } })],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }